<!-- <div style="display: flex; justify-content: space-between; margin: 5px;font-size:x-small;">
<div>
  <div class="OverallGradeLabel">Game</div>
  <div [class]="this.classesRankingBox[this.GamePerformance]"></div>{{this.GamePerformanceText}}
</div>
<div>
  <div class="OverallGradeLabel">Capacity</div>
  <div [class]="this.classesRankingBoxCapacity[floor(this.Capacity)]"></div>{{this.CapacityText}}
</div>
<div>
  <div class="OverallGradeLabel">Projection</div>
  <div [class]="this.classesRankingBoxProjection[this.TotalQuality]"></div>{{this.TotalQualityText}}
</div>
</div> -->
<div style="display: flex; flex-direction: column; justify-content: start; gap: 5px; margin: 5px;font-size:small;">

  <div style="display: flex; flex-direction: row; gap: 5px;">
  @if (this.Capacity!==0) {
    <div [class]="this.classesRankingBoxCapacity[floor(this.Capacity)]">
      {{this.CapacityText}}
    </div>
  }

  @if (this.PlayerType!==0 && this.PlayerType!=null) {
    <div class="grayshading">
    {{this.PlayerTypeText}}</div>
  }
  </div>
  <div style="display: flex; flex-direction: row; gap: 5px;">
    @if (this.CurrentLevel!==0 && this.CurrentLevel!=null) {
    <div [class]="'outlined_' +this.classesRankingBoxProjection[floor(this.CurrentLevel)]">{{this.CurrentLevelText}}</div>
    <mat-icon>arrow_forward</mat-icon>
    }

    <div [class]="this.classesRankingBoxProjection[floor(this.TotalQuality)]">{{this.TotalQualityText}}</div>
  </div>

</div>
